import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  AfterViewInit,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PremiumComponent } from '../premium/premium.component';
import { ModalComponent } from '../editor/additional/modals/modal.component';
import { IconsComponent } from '../editor/additional/icons/icons.component';
import { ApidataService } from '../apidata.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  template: `
    <ng-container>
      <app-modal
        parent="premium-modal-once"
        [style]="{
          borderRadius: '0.75rem',
          border: '1px solid oklch(0.82 0.1471 171.99 / 25.5%)'
        }"
      >
        <modal-content>
          <section>
            <div class="flex justify-between">
              <h3 class="mt-1 mb-0">
                {{ 'Plan&Features.Grammarin-Premium' | translate }}
              </h3>

              <button style="background: transparent" (click)="dismissModal()">
                <app-icons name="closeModalIcon"></app-icons>
              </button>
            </div>

            <p class="fw-medium">
              {{ 'Plan&Features.Upgrade-plan' | translate }}
            </p>

            <app-premium [heading]="false" />

            <div class="flex flex-col items-center mt-3">
              <a
                href="/pricing"
                target="_blank"
                class="upgrade-to-premium-button"
              >
                {{ 'Plan&Features.View-All' | translate }}
              </a>
            </div>
          </section>
        </modal-content>
      </app-modal>
    </ng-container>
  `,
  styles: [
    `
      .flex {
        display: flex;
      }
      .justify-between {
        justify-content: space-between;
      }
      .items-center {
        align-items: center;
      }
      .flex-col {
        flex-direction: column;
      }
      button {
        border: none;
      }
      .upgrade-to-premium-button {
        background-color: #08ba9c;
        color: #ffffff;
        padding-inline: 0.8rem;
        padding-block: 0.35rem;
        border-radius: 0.3rem;
        font-weight: 500;
      }

      .upgrade-to-premium-button:hover {
        text-decoration: none;
      }
    `,
  ],
  selector: 'app-premium-modal-startup',
  imports: [PremiumComponent, ModalComponent, IconsComponent, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PremiumModalStartupComponent implements AfterViewInit {
  private platformId = inject(PLATFORM_ID);
  isBrowser = false;

  constructor(private apiDataService: ApidataService) {
    //
  }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.getCookie('htpd2m')) return;

    document.cookie = 'htpd2m=true; path=/; max-age=3600; SameSite=Lax';

    const profile_id = localStorage.getItem('profile_id');

    if (!profile_id || profile_id == '1') {
      this.showModal();
      return;
    }

    this.apiDataService.getUserProfileContents(profile_id).subscribe((data) => {
      if (data.contents[0][5] !== 'premium_user') {
        this.showModal();
      }
    });
  }

  showModal() {
    setTimeout(() => {
      const modal = document.getElementById('premium-modal-once');

      modal.style.display = 'grid';
    }, 10000);
  }

  dismissModal() {
    const modal = document.getElementById('premium-modal-once');

    modal.style.display = 'none';
  }

  private getCookie(name: string): boolean {
    const match = document.cookie.match(
      new RegExp('(^| )' + name + '=([^;]+)')
    );

    return match ? match[2] === 'true' : false;
  }
}
